// data validated in AEM
import { UeReference } from '@oneaudi/falcon-tools';
import React from 'react';

import { StyledContentTileContainer } from '../ContentTiles/styles';
import { TileSizes, TileSizesNewBehaviour } from '../ContentTiles/tileSizes';
import {
  getEffectiveLayoutSize,
  handleSetTileHeights,
  setMobileTileHeights,
  setTileHeights,
} from '../ContentTiles/utils';

import { ContentTile } from './Component';
import {
  getClickEvent,
  getClickEventAction,
  getSanitizedUrl,
} from '../../../tracking/getClickEvent';
import { useTrackingService } from '../../hooks/useTrackingService';

export function ContentTileContainer({
  index,
  tileData,
  setSize,
  setTileHeightsDirectly,
  leadCardIndex,
  layoutName,
  layoutSize,
  width,
  isTest,
  useNewAspectRatioBehavior,
}) {
  const { trackingService } = useTrackingService();
  const effectiveLayoutSize = getEffectiveLayoutSize(layoutName, layoutSize);
  const resolvedLayoutSize = useNewAspectRatioBehavior ? effectiveLayoutSize : layoutSize;
  const directTileSizes = useNewAspectRatioBehavior ? TileSizesNewBehaviour : TileSizes;
  const onTileClick = (e) => {
    if (trackingService) {
      const sanitizedUrl = getSanitizedUrl(trackingService, tileData);
      const eventAction = getClickEventAction(trackingService, sanitizedUrl);
      const event = getClickEvent(eventAction, sanitizedUrl, tileData, index);

      trackingService.track({ event });
      e.stopPropagation();
    }
  };
  return (
    <StyledContentTileContainer width={width} layout={layoutName}>
      <UeReference key={index} propertyPath={`tiles.${index}`} behavior="component">
        {(ueProps) => {
          return (
            <ContentTile
              key={index}
              index={index}
              layoutName={layoutName}
              layoutSize={resolvedLayoutSize}
              {...tileData}
              media={{
                ...tileData.media,
                useNewAspectRatioBehavior,
                image: {
                  ...tileData.media.image,
                  useNewAspectRatioBehavior,
                },
                video: {
                  ...tileData.media.video,
                  useNewAspectRatioBehavior,
                },
              }}
              size={
                setSize && !setTileHeightsDirectly
                  ? handleSetTileHeights(
                      index,
                      layoutName,
                      resolvedLayoutSize,
                      useNewAspectRatioBehavior,
                    )
                  : setSize && setTileHeightsDirectly
                    ? setTileHeights(directTileSizes[layoutName].sizeTwo[resolvedLayoutSize])
                    : null
              }
              mobileBreakpointSizes={{
                s: setMobileTileHeights(
                  index,
                  leadCardIndex,
                  '375 breakpoint',
                  resolvedLayoutSize,
                  layoutName,
                  useNewAspectRatioBehavior,
                ),
                m: setMobileTileHeights(
                  index,
                  leadCardIndex,
                  '768 breakpoint',
                  resolvedLayoutSize,
                  layoutName,
                  useNewAspectRatioBehavior,
                ),
              }}
              onClickEvent={onTileClick}
              isTest={isTest}
              {...ueProps}
            />
          );
        }}
      </UeReference>
    </StyledContentTileContainer>
  );
}

ContentTileContainer.displayName = 'ContentTileContainer';
